import {
  Button,
} from "alm-react-components";
import {useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppProvider";

import {
  Sheet,
  SheetContent,
  SheetTrigger
} from "alm-react-components";

import LSLogo from "../../assets/images/lnner-stance-logo.svg";

import { useTranslation } from "react-i18next";
import {
  ActionType,
  APPROUTES,
  SET_POPUP_TIMEOUT_DURATION,
} from "../../assets/constants/constants";
import exercisesIcon from "../../assets/images/svgicons/exercises-history.svg";
import membersIcon from "../../assets/images/svgicons/members.svg";
import SessionTimeoutPopup from "../../components/common/SessionTimeoutPopup";
import useIdleSessionTimer from "../../hooks/useIdleSessionTimer";
// import useNotification from "../../hooks/useNotification";
import useQuaterDetail from "../../hooks/useQuaterDetail";
import { logClick, removeChainlitPopup } from "../../lib/utils";
// import { useLocation } from "react-router-dom";
import { UserProfileSection } from './UserProfileSection';
function Header({ hideTabs }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const location = useLocation();
  const { state,dispatch } = useContext(AppContext);
  // const [sheetVisible, setSheetVisible] = useState(false);
  // const { getNotifications, setNotificationCount } = useNotification();
  const { getQuaterDetails } = useQuaterDetail();
  useEffect(() => {
    if(state?.user?.userId) 
      getQuaterDetails();
  }, [ state?.user?.userId ]);

  const [isSideBarVisible, setIsSideBarVisisble] = useState(false);
  const selection = location.pathname;

  // const closeSheet = () => {
  //   setSheetVisible(false);
  //   setNotificationCount(0);
  // };
  const closeHamburgerList = () => {
    setIsSideBarVisisble(false);
  };

  // const openSheet = () => {
  //   setSheetVisible(true);
  // };
  const userId: any = state.user?.userId;

  // const fetchData = async () => {
  //   try {
  //     if (userId) {
  //       await getNotifications(0);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // useEffect(() => {
  //   if (state.settings) {
  //     if (
  //       state?.settings?.notification?.enableOtherNotification === 1 &&
  //       state?.settings?.notification?.enableDailyRemainder === 1
  //     ) {
  //       fetchData();
  //     }
  //   }
  // }, [state.settings]);

  

  // const handleNotification = async () => {
  //   if (
  //     state?.settings?.notification?.enableOtherNotification === 1 ||
  //     state?.settings?.notification?.enableDailyRemainder === 1
  //   ) {
  //     if (state.notificationCount > 0) {
  //       try {
  //         // Update only notifications that are not marked as "action taken"
  //         const notificationsToUpdate = state.notifications?.filter(
  //           (e: any) => !e?.attributes?.actionTaken
  //         );

  //         if (notificationsToUpdate.length > 0) {
  //           await Promise.all(
  //             notificationsToUpdate.map((notification: any) =>
  //               apis.patchUserNotifications(userId, notification)
  //             )
  //           );
  //           setNotificationCount(0);
  //         }
  //       } catch (error) {
  //         console.error("Failed to update notifications:", error);
  //       }
  //     }
  //     // Open the notification sheet
  //     openSheet();
  //   }
  // };

  const onClicLogo = () => {
    logClick();
    navigate(APPROUTES.home);
  };

  let pathname = "";
  if (state?.isAuthenticated === true) {
    pathname = window.location.pathname;
  }

  ////  log user out after 1 hour of idleness

  // old code paste here -just for logout

  // Initialize the idle session timer with handlers
  const { resetTimers, logoutUser } = useIdleSessionTimer({
    timeout: SET_POPUP_TIMEOUT_DURATION,
    onIdle: handleIdle,
  });

  // Show the session timeout popup when user is idle
  function handleIdle() {
    dispatch({
      type: ActionType.SESSION_TIMEOUT_POPUP,
      payload: {
        visible: true,
        message: t("Common.sessionTimeoutAlertMessage"),
      },
    });
  }

  // Extend session and reset the timer when user clicks "Yes"
  const extendSessionTime = () => {
    resetTimers(); // Reset all timers and update lastActiveTimestamp
    dispatch({
      type: ActionType.SESSION_TIMEOUT_POPUP,
      payload: { visible: false, message: "" },
    });
  };

  // Logout user if session is not extended
  const handleLogout = () => {
   // Remove chainit popup
    removeChainlitPopup();
    
    // Clear the context and navigate to the login page
    logoutUser(); // Clear session-related data
    dispatch({
      type: ActionType.CLEAR_CONTEXT,
      payload: true,
    });
    // Force a full page reload to ensure clean logout
    navigate("/", { replace: true });
  };

  // Auto-logout when the popup timer expires
  const handleIdleTimeout = () => {
    handleLogout();
  };

  // Reset session popup visibility when logging in
  const handleLogin = () => {
    resetTimers(); // Reset timers on login
    dispatch({
      type: ActionType.SESSION_TIMEOUT_POPUP,
      payload: { visible: false, message: "" },
    });
  };

  useEffect(() => {
    // Call handleLogin when the page is loaded (e.g., after successful login)
    if (state?.user) {
      handleLogin();
    }
  }, [state?.user]);
  //

  return (
    <>
      {state.sessionTimeoutPopup && state.sessionTimeoutPopup?.visible && (
        <SessionTimeoutPopup
          onExtendSessionTime={extendSessionTime}
          onLogout={handleLogout}
          onIdleTimeout={handleIdleTimeout}
        />
       )}


    <nav className={`bg-white border-gray-200 dark:bg-fillNavbar top-0 fi z-[3] ${!pathname.includes("coach-tool") ? "fixed  w-full" : "fixed coach-tool-nav"}`}>
        {/* <Button onClick={()=>handleLanguage("en")}>English</Button>
    <Button onClick={()=>handleLanguage("es")}>Spanish</Button> */}
      <div className={`mx-auto w-full flex items-center justify-between py-4 z-[100] relative ${!pathname.includes("coach-tool") ? "xl:px-32 lg:px-8 md:px-8 px-5" : "px-8 lg:px-14 2xl:px-[139px]"}`}>
        {!pathname.includes("coach-tool") && <div className="flex items-center lg:justify-between w-full">
          
              {/* For Mobile Navigation Link */}
              {userId && (
                <div className="flex lg:hidden">
              <Sheet  open={isSideBarVisible} onOpenChange={setIsSideBarVisisble}>
                  <SheetTrigger asChild>
                <Button variant="outline" className="-m-2.5 mr-2 inline-flex items-center justify-center rounded-md p-1 text-white">
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                      </svg>
                    </Button>
                  </SheetTrigger>
                  <SheetContent className="pl-3 pr-4">
                    <div className="grid gap-4 py-4">
                      <div className="space-y-2">
                        {state.isAuthenticated && !hideTabs && (
                          <div
                            className="flex lg:hidden items-center justify-between w-full sm:w-auto sm:order-1 sm:ps-2"
                            id="navbar-user"
                          >
                            <ul className="flex flex-col w-full ">
                              <li className="relative flex select-none text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 cursor-pointer p-0 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none w-full">
                                <Link
                                  to={"/home/quater-list"}
                            className={`font-helveticaMedium text-lg h-auto rounded-none text-un-none no-underline ${pathname.split("/")[1] === "program-overview" ||
                                    pathname.split("/")[2] === "program" ||
                                pathname.split("/")[2] === "course-detail"||
                                pathname.split("/")[2]==="quater-list"
                                      ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                                : ""}`}
                                  onClick={closeHamburgerList}
                                >
                            <span dangerouslySetInnerHTML={{ __html: t('Header.programs') }} />
                                </Link>
                              </li>
                              <li className="relative flex select-none text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 cursor-pointer p-0 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none w-full">
                                <Link
                                  to={"/home/library"}
                            className={`font-helveticaMedium text-lg h-auto rounded-none text-un-none no-underline  ${pathname == "/home/library" || pathname == "/home/library/"
                                      ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                              : ""}`}
                                  onClick={closeHamburgerList}
                                >
                            <span dangerouslySetInnerHTML={{ __html: t('Header.library') }} />
                                </Link>
                              </li>
                              <li className="relative flex select-none text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 cursor-pointer p-0 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none w-full">
                                <Link
                                  to={"/home/my-stance"}
                            className={`font-helveticaMedium text-lg h-auto rounded-none text-un-none no-underline  ${pathname == "/home/my-stance" || pathname == "/home/my-stance" ||
                                    pathname.split("/")[1] === "allprograms"
                                      ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                                : ""}`}
                                  onClick={closeHamburgerList}
                                >
                            <span dangerouslySetInnerHTML={{ __html: t('Header.myStance') }} />
                                </Link>
                              </li>
                              <li className="relative flex select-none text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 cursor-pointer p-0 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none w-full">
                                <Link
                          to={"https://join.slack.com/t/innerstancecommunity/shared_invite/zt-36pe56wcn-1yeFpKzMVX6MFJMowWdHFQ"}
                            className={`font-helveticaMedium text-lg h-auto rounded-none text-un-none no-underline`}
                                  onClick={closeHamburgerList}
                                                           target="_blank"

                                >
                            <span dangerouslySetInnerHTML={{ __html: t('Header.community') }} />
                                </Link>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </SheetContent>
                </Sheet>


              </div>
              )}
              {/* For Mobile Navigation Link End */}

              {/* For Web Navigation Link */}
              <div className="flex">
                <span
                  // to={"/home"}
              onClick={()=>onClicLogo()}
                  className="flex items-center lg:mr-12 space-x-3 rtl:space-x-reverse bg-fillNavbar cursor-pointer"
                >
                <img src={LSLogo} className="h-8 lg:h-12 bg-fillNavbar cursor-pointer" alt="INNER STANCE" />
                  <span className="self-center max-sm:hidden max-md:text-base lg:text-xl whitespace-nowrap dark:text-white lg:block cursor-pointer">
                    <span dangerouslySetInnerHTML={{ __html: t("Header.innerStance") }} />
                  </span>
                </span>
                {state.isAuthenticated && !hideTabs && (
                  <div
                    className="hidden lg:flex items-center justify-between w-full lg:ml-12 lg:mr-8 sm:w-auto sm:order-1 sm:ps-6"
                    id="navbar-user"
                  >
                    <ul className="flex flex-col font-medium text-xl p-4 sm:p-0 mt-4 border border-gray-100 rounded-lg bg-transparent sm:space-x-8 rtl:space-x-reverse sm:flex-row sm:mt-0 sm:border-0">
                      <li>
                        <Link
                          to={"/home/quater-list"}
                      className={`pb-5 pt-5 font-helveticaRegular text-lg h-auto rounded-none text-un-none ${pathname.split("/")[2] === "quater-list" ||
                            pathname.split("/")[2] === "program-overview" ||
                            pathname.split("/")[2] === "program"
                              ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                        : ""}`}
                        >
                        <span dangerouslySetInnerHTML={{ __html: t('Header.programs') }} />
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={"/home/library"}
                      className={`pb-5 pt-5 font-helveticaRegular text-lg h-auto rounded-none text-un-none ${pathname == "/home/library" || pathname == "/home/library/"
                              ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                        : ""}`}
                        >
                      <span dangerouslySetInnerHTML={{ __html: t('Header.library') }} />
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={"/home/my-stance"}
                      className={`pb-5 pt-5 font-helveticaRegular text-lg h-auto rounded-none text-un-none ${pathname == "/home/my-stance"
                              ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                              : ""
                          }`}
                        >
                      <span dangerouslySetInnerHTML={{ __html: t('Header.myStance') }} />
                        </Link>
                      </li>
                      
                      <li>
                        <Link
                          to={"https://join.slack.com/t/innerstancecommunity/shared_invite/zt-36pe56wcn-1yeFpKzMVX6MFJMowWdHFQ"}
                          className={`pb-5 pt-5 font-helveticaRegular text-lg h-auto rounded-none text-un-none`}
                          target="_blank"
                        >
                      <span dangerouslySetInnerHTML={{ __html: t('Header.community') }} />
                        </Link>
                      </li>
                    </ul>

                  </div>
                )}
              </div>
              {/* For Web Navigation Link End */}
        </div>}

        {pathname.includes("coach-tool") &&<div className="flex items-center pe-0 lg:pe-4">
              <div className="flex lg:hidden">
          <Sheet open={isSideBarVisible} onOpenChange={setIsSideBarVisisble}>
                  <SheetTrigger asChild>
                    <Button
                      variant="outline"
                      className="-m-2.5 mr-2 inline-flex items-center justify-center rounded-md p-1 text-white"
                    >
                      <svg
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                        />
                      </svg>
                    </Button>
                  </SheetTrigger>
                  <SheetContent className="pl-3 pr-4">
                    <div className="grid gap-4 py-4">
                      <div className="space-y-2">
                        <div
                          className="flex lg:hidden items-center justify-between w-full sm:w-auto sm:order-1 sm:ps-2"
                          id="navbar-user"
                        >
                          <div className="flex flex-col flex-1 overflow-y-auto">
                            <nav className="flex-1 px-2 py-4">
                              <Link
                                to={""}
                          onClick={(e:any) => {e.preventDefault();navigate("/coach-tool/members");closeHamburgerList()}}
                                className={`flex items-center font-barlowRegular font-medium p-4 mb-1 text-gray-100 ${
                            selection === "/coach-tool/members" ? "dark:bg-navActive" :""
                                } dark:hover:bg-navActive  text-xl rounded-lg`}
                              >
                                <img
                            className={`${selection === "/coach-tool/members" ? "yellow" : "white"} logo text-sm mr-4 w-8 h-8`}
                                  src={membersIcon}
                                  alt="Members"
                                />
                                <span dangerouslySetInnerHTML={{ __html: t("coachTool.members") }} />
                              </Link>
                              <Link
                                to={""}
                                className={`flex items-center font-barlowRegular font-medium p-4 mb-1 text-gray-100 ${
                            selection === "/coach-tool/exercises" ? "dark:bg-navActive" : ""
                                } dark:hover:bg-navActive  text-xl rounded-lg`}
                              >
                                <img
                            className={`${selection === "/coach-tool/exercises" ? "yellow" : "white"}  logo text-sm mr-4 w-8 h-8`}
                                  src={exercisesIcon}
                                  alt="exercises"
                                />
                                <span dangerouslySetInnerHTML={{ __html: t("coachTool.exercises") }} />
                              </Link>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SheetContent>
                </Sheet>
              </div>

              <div className="flex items-center justify-center max-sm:h-[40px] lg:h-[75px] mr-6 lg:hidden">
                <Link
                  to={"/home"}
                  className="flex items-center space-x-3 rtl:space-x-reverse"
                >
            <img src={LSLogo} className="h-7" alt={t("Header.innerStance")}/>
                </Link>
              </div>
              <Button
                variant="secondary"
                className=" text-sm lg:text-base font-normal px-3 lg:px-6 py-1 h-auto lgh-9 border dark:border-white hidden"
              >
                <span dangerouslySetInnerHTML={{ __html: t("coachTool.text") }} />
              </Button>
        <h1 className="text-sm lg:text-xl font-barlowRegular max-sm:flex-none"><span dangerouslySetInnerHTML={{ __html: t("coachTool.text") }} /></h1>
        </div>}

          <div className="flex items-center md:order-2 space-x-3 md:space-x-3 lg:justify-end ">
            {/* Select */}
            {/* Select */}
            {/* Notifications */}
            {(state.settings?.notification?.enableOtherNotification &&  !pathname.includes("coach-tool")) ?
            (<> 
                {/* <Sheet open={sheetVisible} onOpenChange={setSheetVisible}> 
               <SheetTrigger asChild>  */}
                   <Button
                    variant="link"
                    size="icon"
                    className="mx-4 max-md:left-2 left-2 relative inline-flex p-0 items-center text-sm font-medium text-center text-white bg-transparent hover:bg-transparent"
                    aria-label="Notification"
                    // onClick={() => handleNotification()}
                  />
                    {/* <span className="sr-only" dangerouslySetInnerHTML={{ __html: t("Notifications.notificationText") }} />
                    {state.notificationCount > 0 &&
                      <div className="absolute p-0 inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-600 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
                        {state.notificationCount}
                      </div>
                    } */}
                {/* </SheetTrigger> */}
                {/* <SheetContent className="p-0 top-[0px] z-[50] border-0 dark:bg-fillLightGrayCard sm:max-w-[533px] max-sm:w-full">
                  <SheetHeader className="dark:bg-fillNavbar border-b-[1px] border-slate-700 px-10 pt-6">
                    <SheetTitle className="text-xl font-barlowRegular font-normal pb-5 h-auto rounded-none mx-[13px] ml-0 border-primary border-b-[5px] w-max">
                      <span dangerouslySetInnerHTML={{ __html: t("Header.notificationText") }} />
                    </SheetTitle>
                  </SheetHeader>
                  <ScrollArea className="">
                    <NotificationModal
                      notifications={state.notifications}
                      closeSheet={closeSheet} />
                  </ScrollArea>
                </SheetContent> */}
                {/* </Sheet> */}
                </>) :(<></>)
                }  
            {/* profile */}
            <UserProfileSection />
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
